import { forEach } from "lodash";
import { BASE_API_URL } from "../../constants";
import { ZODIAC_CALENDAR } from "../../routes/links";

export const ENDPOINTS = {
  POST_LOGIN: "/auth/login",
  CREATE_USER: "/users/crate",
  GET_PAGE_CONTENT: "/data-content/:dataCode",
  SAVE_PAGE_CONTENT: "/data-content/:dataCode",
  TOGGLE_PUBLISH_PAGE_CONTENT: "/data-content/:dataCode/toggle-publish",

  GET_LIST_ZODIAC: "/zodiac",
  ADD_ZODIAC: "/zodiac",
  BULK_ZODIAC: "/zodiac/bulk",
  UPDATE_ZODIAC: "/zodiac/:id",
  DELETE_ZODIAC: "/zodiac/:id",
  ZODIAC_TOGGLE_PUBLISH: "/zodiac/:id/toggle-publish",

  ZODIAC_LOVE_LIST: "/zodiac-love",
  ZODIAC_LOVE_ADD: "/zodiac-love",
  ZODIAC_LOVE_EDIT: "/zodiac-love/:id",
  ZODIAC_LOVE_DELETE: "/zodiac-love/:id",
  ZODIAC_LOVE_BULK: "/zodiac-love/bulk",
  ZODIAC_LOVE_TOGGLE_PUBLISH: "/zodiac-love/:id/toggle-publish",

  ZODIAC_CALENDAR_LIST: "/zodiac-calendar",
  ZODIAC_CALENDAR_BULK: "/zodiac-calendar/bulk",
  ZODIAC_CALENDAR_ADD: "/zodiac-calendar",
  ZODIAC_CALENDAR_EDIT: "/zodiac-calendar/:id",
  ZODIAC_CALENDAR_DELETE: "/zodiac-calendar/:id",
  ZODIAC_CALENDAR_TOGGLE_PUBLISH: "/zodiac-calendar/:id/toggle-publish",

  ZODIAC_RANKING_LIST: "/zodiac-ranking",
  ZODIAC_RANKING_BULK: "/zodiac-ranking/bulk",
  ZODIAC_RANKING_ADD: "/zodiac-ranking",
  ZODIAC_RANKING_EDIT: "/zodiac-ranking/:id",
  ZODIAC_RANKING_DELETE: "/zodiac-ranking/:id",
  ZODIAC_RANKING_TOGGLE_PUBLISH: "/zodiac-ranking/:id/toggle-publish",

  TAROT_LIST_DECKS: "/tarot-decks",
  TAROT_GET_ONE_SUIT: "/tarot-suits/:id",
  TAROT_UPDATE_CARD: "/tarot-cards/:id",
  TAROT_UPDATE_DECK: "/tarot-decks/:id",
  TAROT_GET_ONE_CARD: "/tarot-cards/:id",
};

export const getApiUrl = (
  endpoint: string,
  params?: any,
  isParamId: boolean = false
): string => {
  let path = endpoint;
  if (params) {
    if (isParamId) {
      forEach(params, (value, key) => {
        const replace = `:${key}`;
        if (path.indexOf(replace) !== -1) {
          const re = new RegExp(replace, "g");
          path = path.replace(re, value.toString());
        }
      });
    } else {
      path = path + "?" + new URLSearchParams(params).toString();
    }
  }
  const baseApi = BASE_API_URL;
  return baseApi + path;
};

export const parseParamUrl = (
  endpoint: string,
  params?: any,
  query?: any
): string => {
  let path = endpoint;
  if (params) {
    forEach(params, (value, key) => {
      const replace = `:${key}`;
      if (path.indexOf(replace) !== -1) {
        const re = new RegExp(replace, "g");
        path = path.replace(re, value.toString());
      }
    });
  }
  if (query) {
    path = path + "?" + new URLSearchParams(query).toString();
  }
  return path;
};
